<template>
  <section>
    <div v-if="announcement.isAllJurisdictions" class="tag is-light has-text-grey is-size-5">
      <span>{{ $t('announcement.all-jurisdictions') }}</span>
    </div>
    <div v-else-if="announcement.appliesToCanada" class="tag is-light has-text-grey is-size-5">
      <span>{{ $t('announcement.all-jurisdictions-canada') }}</span>
    </div>
    <div v-else-if="announcement.appliesToUSA" class="tag is-light has-text-grey is-size-5">
      <span>{{ $t('announcement.all-jurisdictions-usa') }}</span>
    </div>
    <ExpandableIndicatorList v-else :data="items">
      <template #item="{ item }">
        <div class="tag is-light has-text-grey is-size-5">
          {{ item }}
        </div>
      </template>

      <template #expand-indicator="{ hiddenItemsCount }">
        <div class="tag is-light has-text-primary is-size-5 has-text-weight-bold">
          +{{ hiddenItemsCount }}
        </div>
      </template>

      <template #reduce-indicator>
        <div class="tag is-light has-text-primary is-size-5 has-text-weight-bold">
          {{ $t('core.show-less') }}
        </div>
      </template>
    </ExpandableIndicatorList>
  </section>
</template>

<script>
import { Announcement } from '@/modules/announcement/models/Announcement';
import { AnnouncementCypressAttribute } from '@/modules/announcement/constants/AnnouncementCypressAttribute';
import { PredefinedCountry } from '@/modules/predefined/enums/PredefinedCountry';
import ExpandableIndicatorList from '@/modules/core/app/components/ExpandableIndicatorList.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'AnnouncementJurisdictionTags',
  components: {
    ExpandableIndicatorList
  },
  props: {
    announcement: {
      type: Announcement,
      required: true
    }
  },
  static: {
    AnnouncementCypressAttribute,
    PredefinedCountry
  },
  computed: {
    items() {
      return [...this.announcement.countries, ...this.announcement.jurisdictions];
    }
  }
};
</script>
